/* eslint react-hooks/exhaustive-deps: "warn" */

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './SectionWhatsNext.module.scss';

const EVIDENCE_ROWS = [
  {
    num: '01',
    title: 'The source registry',
    desc: 'Every record names the official registry it came from.',
  },
  {
    num: '02',
    title: 'The original filing',
    desc: 'A link back to the document the company filed.',
  },
  {
    num: '03',
    title: 'The retrieval date',
    desc: 'When we collected it, so freshness is never a guess.',
  },
];

const NEXT_ITEMS = [
  {
    num: '01',
    title: 'AI models',
    desc: 'Trained and grounded in official registry data.',
  },
  {
    num: '02',
    title: 'Ownership graphs',
    desc: 'Relationships and structures, mapped across borders.',
  },
  {
    num: '03',
    title: 'Intelligent agents',
    desc: 'Investigate a company, watch it for changes, flag risk.',
  },
];

export const SectionWhatsNext = () => (
  <Section background="#DCE2F5">
    <div className={styles.inner}>
      {/* Vision block */}
      <div className={styles.vision}>
        <div className={styles.visionMain}>
          <div className={styles.visionKicker}>Our mission</div>
          <p className={styles.visionText}>
            A world where every company decision, made by a person or an AI, is grounded in trusted evidence.
          </p>
        </div>

        <div className={styles.visionProof}>
          <div className={styles.proofKicker}>What trusted evidence means</div>
          {EVIDENCE_ROWS.map((row) => (
            <div key={row.num} className={styles.proofRow}>
              <span className={styles.proofNum}>{row.num}</span>
              <div>
                <strong className={styles.proofTitle}>{row.title}</strong>
                <p className={styles.proofDesc}>{row.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* What's next block */}
      <div className={styles.head}>
        <div className={styles.rail}>
          <span className={styles.eyebrow}>05</span>
          <p className={styles.railTitle}>What&#39;s next</p>
        </div>

        <div className={styles.headContent}>
          <TitleBlock
            title={
              <>We spent a decade building the data. Now we&#39;re teaching AI to reason over&nbsp;it.</>
            }
            description="The hard part is done: company data collected from official registries across the world, connected into one system. Now it becomes the ground truth."
            align="left"
            className={styles.titleBlock}
          />

          <div className={styles.nextList}>
            {NEXT_ITEMS.map((item) => (
              <div key={item.num} className={styles.nextItem}>
                <span className={styles.nextNum}>{item.num}</span>
                <div>
                  <strong className={styles.nextTitle}>{item.title}</strong>
                  <p className={styles.nextDesc}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </Section>
);
